<template>
    <div>
        <div class="column-layout">
            <div v-if="checkBox" class="table-layout">
                <el-table ref="operatorComList" :data="operatorComList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="checkBox" :selectable="selectable" type="selection" width="55"></el-table-column>
                    <el-table-column prop="name" label="显示名称" align="left"></el-table-column>
                    <el-table-column prop="contactName" label="联系人" align="left"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话" align="center"></el-table-column>
                    <el-table-column prop="contactEmail" label="联系电子邮箱" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table :data="operatorComList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checkOperatorComInfo!= null && checkOperatorComInfo.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="显示名称" align="left"></el-table-column>
                    <el-table-column prop="contactName" label="联系人" align="left"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话" align="center"></el-table-column>
                    <el-table-column prop="contactEmail" label="联系电子邮箱" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import retailerApi from '../../api/retailer'

    export default {
        name: 'swb-retailer-com-list-for-select',
        desc: '零售商基本信息',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            operatorComListIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                operatorComList: [],
                pageNumber: 1,
                totalCount: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                selectOperatorComList: [],
                checkOperatorComInfo: null
            }
        },
        created: function () {
            let self = this;
            //
            self.getRetailerComList();
        },
        methods: {
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getRetailerComList();
            },
            getRetailerComList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.filterItems = self.filter;
                retailerApi.getRetailerShopList(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data;
                        let operatorComList = data.rows;
                        //
                        self.operatorComList = operatorComList;
                        self.totalCount = data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let operatorComListIds = this.operatorComListIds;
                if(operatorComListIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectOperatorComList = val;
            },
            handleCurrentChange: function (val) {
                this.checkOperatorComInfo = Utils.merge({}, val);
            },
            getOperatorComInfo: function (checkOperatorComInfo) {
                let operatorComInfo = {};
                if(checkOperatorComInfo != null) {
                    operatorComInfo.id = checkOperatorComInfo.id;
                    operatorComInfo.comId = checkOperatorComInfo.id;
                    operatorComInfo.name = checkOperatorComInfo.name;
                    operatorComInfo.contactName = checkOperatorComInfo.contactName;
                    operatorComInfo.contactTel = checkOperatorComInfo.contactTel;
                    operatorComInfo.contactEmail = checkOperatorComInfo.contactEmail;
                }
                return operatorComInfo;
            },
            getOperatorComList: function () {
                let operatorComList = [];
                let operatorComs = this.selectOperatorComList;
                if(operatorComs != null && operatorComs.length > 0) {
                    for(var i = 0; i < operatorComs.length; i++) {
                        let operatorComInfo = operatorComs[i];
                        let operatorCom = this.getOperatorComInfo(operatorComInfo);
                        operatorComList.push(operatorCom);
                    }
                }
                return operatorComList;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let selectOperatorComList = self.selectOperatorComList;
                    if(selectOperatorComList != null && selectOperatorComList.length > 0) {
                        result.type = "info";
                        result.data = self.getOperatorComList();
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个机构！';
                    }
                } else {
                    let operatorComInfo = self.checkOperatorComInfo;
                    if(operatorComInfo != null) {
                        result.type = "info";
                        result.data = self.getOperatorComInfo(operatorComInfo);
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个机构！';
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/retailer/RetailerComListForSelect.vue